export default "__VITE_ASSET__CQmHlODY__"